export const getIsLoading = (state) => state.propertyAvailability?.isLoading;

export const getAvailableRoomTypes = (state) => state.propertyAvailability.roomTypes;
